import { Component } from 'react'
import styled from 'glamorous'
import { graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { compose } from 'react-apollo'

import { $ } from 'utils'
import { withConsumer } from 'store'
import { Loader } from 'components'
import { SEARCH } from 'queries'

import PersonsList from '../Persons/PersonsList';


const Container = styled.div({
  position: 'relative',
  width: 800,
  height: '100%',
  overflow: 'hidden'
})

const Header = styled.div({
  fontSize: 30,
  fontWeight: 600,
  marginBottom: 50
})


class SearchPage extends Component {

  render() {
    const { data: { loading, search }, match } = this.props
    if (loading && !search) return $(Loader)
    const persons = search.items ? search : [];

    return (
      $(Container,
        $(Header, `${persons.items.length === 0 ? 'Nothing found' : 'Results'} for "${match.params.search}"`),
        $(PersonsList, { persons })
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(SEARCH, {
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          query: props.match.params.search
        }
      })
    })
  )(withConsumer(SearchPage))
)



// WEBPACK FOOTER //
// ./src/pages/Search/index.js